import React from "react";
import { Flex, Text, Icon, useColorModeValue } from "@chakra-ui/react";
import { MdPerson, MdGroups, MdBusiness } from "react-icons/md";
import { OWNER_TYPE_LABELS } from "./subscriptionsManageConstants";

const ICON_BY_TYPE = {
    user: MdPerson,
    artist_group: MdGroups,
    entity: MdBusiness,
};

/**
 * Renders the owner of a subscription as a labelled chip ("Utilisateur #42").
 * Falls back to "—" when the owner_type is unknown.
 * @param {Object} props
 * @param {string} props.ownerType - One of "user", "artist_group", "entity"
 * @param {number|string} props.ownerId - Numeric owner identifier
 * @returns {React.ReactElement}
 */
function OwnerCell({ ownerType, ownerId }) {
    const chipBg = useColorModeValue("brand.50", "whiteAlpha.100");
    const labelColor = useColorModeValue("secondaryGray.900", "white");
    const TypeIcon = ICON_BY_TYPE[ownerType] || MdPerson;
    const typeLabel = OWNER_TYPE_LABELS[ownerType] || ownerType || "—";
    const idLabel = ownerId != null ? `#${ownerId}` : "—";
    return (
        <Flex align="center" gap="8px">
            <Flex align="center" gap="6px" px="10px" py="4px" borderRadius="999px" bg={chipBg}>
                <Icon as={TypeIcon} color="brand.500" boxSize="14px" />
                <Text color={labelColor} fontSize="0.72rem" fontWeight="600">{typeLabel}</Text>
            </Flex>
            <Text color="secondaryGray.600" fontSize="0.75rem" fontFamily="monospace">{idLabel}</Text>
        </Flex>
    );
}

export default OwnerCell;
